/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this file will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
  // Add custom code below this line

  // --- Collection page: Product/Model image toggle ---
  function initViewToggle() {
    var toggle = document.querySelector('[data-view-toggle]');
    if (!toggle) return;

    var btns = toggle.querySelectorAll('.view-toggle__btn');

    function applyView(view) {
      document.querySelectorAll('[data-grid-item]').forEach(function(item) {
        var defaultImg = item.querySelector('[data-product-image-default]');
        var hoverImg = item.querySelector('.product-item__bg__under');

        if (defaultImg && hoverImg) {
          defaultImg.style.opacity = view === 'model' ? '0' : '1';
          hoverImg.style.opacity = view === 'model' ? '1' : '0';
          hoverImg.style.zIndex = view === 'model' ? '2' : '1';
        }
      });
    }

    // Apply whichever view is marked active on load
    var activeBtn = toggle.querySelector('.view-toggle__btn.active');
    if (activeBtn) {
      applyView(activeBtn.getAttribute('data-view'));
    }

    btns.forEach(function(btn) {
      btn.addEventListener('pointerdown', function(e) {
        e.stopPropagation();
        e.preventDefault();

        var view = this.getAttribute('data-view');
        btns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        applyView(view);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initViewToggle);
  } else {
    initViewToggle();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// --- Product page: Default to second image on load ---
(function() {
  function setDefaultProductImage() {
    if (!document.body.classList.contains('template-product')) return;

    var productImages = document.querySelector('product-images');
    if (!productImages) return;

    var mediaItems = productImages.querySelectorAll('[data-image-id]');
    if (mediaItems.length < 2) return;

    var secondMediaId = mediaItems[1].getAttribute('data-media-id');
    if (!secondMediaId) return;

    productImages.dispatchEvent(new CustomEvent('theme:media:select', {
      detail: { id: secondMediaId }
    }));
  }

  function init() {
    setDefaultProductImage();
    setTimeout(setDefaultProductImage, 50);
    setTimeout(setDefaultProductImage, 300);
    setTimeout(setDefaultProductImage, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Catch the moment the theme's own variant logic finishes and re-assert
  document.addEventListener('theme:variant:change', function() {
    setDefaultProductImage();
  }, { once: true });
})();